import Api from "./Api";
import ReportModel from "@/model/Report";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { SummaryServerResponse } from "@/types/global.d";
class ReportApi extends Api {
  public constructor(config?: AxiosRequestConfig) {
    super(config);
  }

  public getReportByYear(year?: number): Promise<SummaryServerResponse> {
    const url = this.prepareUrl("/disclosurecode/public/summary/", year);
    return this.get<
      SummaryServerResponse,
      AxiosResponse<SummaryServerResponse>
    >(url).then(this.success);
  }
}

export default new ReportApi();
